
import { defineComponent, inject, ref } from "vue"
export default defineComponent({
    props:{
        extra: {
            type: null,
            required: false,
            default: {}
        }
    },
    setup(){
        const altura = screen.height - 220;
        const serverFile = ref<any>(process.env.VUE_APP_SERVER_FILE)
        const urlFile = inject('urlFile');
        const open_dialog_view_file = inject('open_dialog_view_file');
        const gblRowAcrd = inject<any>('gblRowAcrd')

        return {
            altura,
            serverFile,
            urlFile,
            open_dialog_view_file,
            gblRowAcrd
        }
    }
    
})
